document.addEventListener("DOMContentLoaded", function() {
  const content = document.getElementById('article-content');
  const toc = document.getElementById('toc-container');
  const headings = content.querySelectorAll('h2');

  if (headings.length === 0) return;

  const links = [];

  // 1. 生成目录并初始化第一个状态
  headings.forEach((heading, index) => {
    const id = `heading-${index}`;
    heading.setAttribute('id', id);

    const link = document.createElement('a');
    link.setAttribute('href', `#${id}`);
    link.textContent = heading.textContent;
    link.classList.add('toc-link');

    // 默认给第一个加上 tabactive
    if (index === 0) {
      link.classList.add('tabactive');
    }

    toc.appendChild(link);
    links.push(link);
  });

  // 2. 创建滚动监听 (Intersection Observer)
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -80% 0px', // 触发位置：当标题滚动到屏幕上方 20% 处时切换
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 移除所有链接的激活类名
        links.forEach(l => l.classList.remove('tabactive'));
        
        // 为当前对应的目录项添加类名
        const id = entry.target.getAttribute('id');
        const activeLink = toc.querySelector(`a[href="#${id}"]`);
        if (activeLink) {
          activeLink.classList.add('tabactive');
        }
      }
    });
  }, observerOptions);

  // 开始观察所有的 h2 标签
  headings.forEach(heading => observer.observe(heading));
});